/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircuitGroundDigital = createReactComponent("outline", "circuit-ground-digital", "IconCircuitGroundDigital", [["path", { "d": "M12 13v-10", "key": "svg-0" }], ["path", { "d": "M12 21l-6 -8h12z", "key": "svg-1" }]]);

export { IconCircuitGroundDigital as default };
//# sourceMappingURL=IconCircuitGroundDigital.mjs.map
